import dayjs from 'dayjs';
import React from 'react';
import { TIME_STAMP_FORMAT, APPLICATION_DATE_FORMAT } from '@utils/index';

interface Props {
  time: string;
}

export function TimeRow(props: Props) {
  const { time } = props;

  return (
    <div className="text-gray_800 font-medium text-sm">
      <span>{dayjs(time).format(TIME_STAMP_FORMAT)}</span>
      <p>{dayjs(time).format(APPLICATION_DATE_FORMAT)}</p>
    </div>
  );
}
